module.exports = __webpack_public_path__ + "images/916ea5fdffdac3f06e8155215e119a18.svg";